module.exports = __webpack_public_path__ + "assets/img/8122ae3a5e8428abe08516af3f42f320.png";